import { Pipe, PipeTransform, LOCALE_ID } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'customDateFormatterPipe'
})
export class CustomDateFormatterPipe implements PipeTransform {

  constructor() { }

  transform(value, ...args: any[]): any {
    const date = new Date(value);
    // tslint:disable-next-line:max-line-length
    const formatted_date = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' - ' + date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
    return formatted_date;
  }

}
